/**
 * ModeHeaderActions.js
 *
 * The notification bell and (when chat is available) the Team Chat button of the
 * premium dashboard headers, each in the round white circle used by the
 * management dashboard. Drop into `GreetingHeader`'s `right` slot.
 *
 * Gating is untouched: {@link useChatHubBadge} decides whether chat is visible
 * for this build / store / role, and the bell resolves its own unread badge.
 *
 * @module components/ModeHeaderActions
 */

import React from 'react';
import {StyleSheet, View} from 'react-native';
import NotificationBellButton from './NotificationBellButton';
import ChatHeaderButton from './chat/ChatHeaderButton';
import {useManagementTheme} from '../helpers/managementTheme';
import {useChatHubBadge} from '../helpers/teamChat/useChatHubBadge';

/**
 * Chat + notification header buttons in round white circles.
 *
 * @returns {JSX.Element} The action row.
 */
export default function ModeHeaderActions() {
    const m = useManagementTheme();
    const {visible: teamChatVisible} = useChatHubBadge();
    const circle = [styles.circle, {backgroundColor: m.colors.surface, borderColor: m.colors.border}, m.shadow(1)];

    return (
        <View style={styles.row}>
            {teamChatVisible && (
                <View style={circle}>
                    <ChatHeaderButton size={21} color={m.colors.heading} />
                </View>
            )}
            <View style={circle}>
                <NotificationBellButton size={21} color={m.colors.heading} />
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    row: {flexDirection: 'row', alignItems: 'center', gap: 8},
    circle: {width: 42, height: 42, borderRadius: 21, borderWidth: 1, alignItems: 'center', justifyContent: 'center'},
});
